import { useCallback } from "react";
import {
  ContextValue,
  SetSwipeDataParams,
} from "components/bookShuffle/useBookShuffle/types";

export default function useCurrentIndex(context: ContextValue) {
  const { dispatch, stateRef } = context;

  /**
   * Proceeds to the next card
   */
  context.goNext = useCallback(() => {
    dispatch({
      type: "adjustCurrentIndex",
      payload: {
        adjustment: 1,
      },
    });
  }, [dispatch]);

  /**
   * Goes back to the previous card
   */
  context.goBack = useCallback(() => {
    dispatch({
      type: "adjustCurrentIndex",
      payload: {
        adjustment: -1,
      },
    });
  }, [dispatch]);

  /**
   * Remove any dialogs that are currently showing
   */
  context.clearDialogs = useCallback(() => {
    dispatch({
      type: "updateState",
      payload: {
        showAcceptedDialog: false,
        showRejectedDialog: false,
      },
    });
  }, [dispatch]);

  /**
   * Marks the current card has been animated out
   */
  context.completeAnimation = useCallback(() => {
    dispatch({
      type: "updateState",
      payload: {
        isAnimating: false,
      },
    });
  }, [dispatch]);
  /**
   * When swiping, this function is called to
   * share the swipe data with other components
   */
  context.setSwipeData = useCallback(
    (params: SetSwipeDataParams) => {
      const { swipeData } = params;

      const { distanceSwiped: oldDistance } = stateRef.current;

      // prevent unnecessary re-renders by rounding the distance
      const distanceSwiped = Math.round(Math.max(
        Math.abs(swipeData.componentCurrentX),
        Math.abs(swipeData.componentCurrentY)
      ));

      if (distanceSwiped === oldDistance) return;

      dispatch({
        type: "updateState",
        payload: {
          distanceSwiped,
        },
      });
    },
    [dispatch, stateRef]
  );
}
